<template>
	<div
		class="cetin-data sprintel-data"
		v-if="results && results.length"
	>

		<span class="company-name"> Sprintel: </span>
        <div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile> 
        </div>
		<div v-else
			v-for="(i, index) of results[0].text"
			:key="index"
			class="sprintel-item cetin-vysledek-card"
		>
			{{ i }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'SprintelResult',

	props: {
		results: { type: Array, default: {} },
        loading: { type: Boolean }
	},
}
</script>

<style lang="stylus" scoped>

.cetin-data
    padding-top 10px
    margin-top 15px
    border-bottom 1px solid #4CA5F9
    border-top 1px solid #4CA5F9

.sprintel-data
    display flex
    flex-direction column

.company-name
    font-weight bold
    font-size 24px

.sprintel-item
    border-bottom 1px dashed #4CA5F9
    border-top 1px dashed #4CA5F9
    padding-bottom 10px
    padding-top 10px

.cetin-vysledek-card
    padding 10px
    background-color white
    border-radius 5px
    margin-right 10px
    margin-bottom 10px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important


</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/SprintelResult.vue